import { resources, dropdownOptions } from "../Resources/SharedResources";
import { ROUTES, getRoutePath } from "../Resources/routes";
import FadeInOnScroll from "./FadeInOnScroll";
import useScrollOrNavigate from "./useScrollOrNavigate";
import { ContactConfig, contactResources } from "../Resources/Contact";

function Footer({ langName }) {
    const lang = langName;
    const handleScrollOrNavigate = useScrollOrNavigate();

    const FooterSection = ({ title, children }) => (
        <div>
            <div className="bold">{title}</div>
            {children}
        </div>
    );

    const FooterLink = ({ label, href, onClick }) => (
        <a className="footer-links" href={href} onClick={onClick}>
            {label}
        </a>
    );

    const FooterContactLink = ({ iconClass, label, href }) => (
        <a className="footer-links-contact" href={href}>
            <i className={`icon ${iconClass}`}></i> {label}
        </a>
    );

    const mainLinks = [
        { label: resources[lang].Home, href: getRoutePath(ROUTES.HOME, lang) },
        { label: resources[lang].About, href: getRoutePath(ROUTES.ABOUT, lang) },
        { label: resources[lang].Services, href: getRoutePath(ROUTES.SERVICES, lang) },
        { label: resources[lang].Industries, href: getRoutePath(ROUTES.INDUSTRIES, lang) },
        { label: resources[lang].Contact, href: getRoutePath(ROUTES.CONTACT, lang) },
    ];

    const socialLinks = [
        { icon: "ion-social-facebook", label: contactResources[lang].facebook, href: ContactConfig.facebook },
        { icon: "ion-social-linkedin", label: contactResources[lang].linkedin, href: ContactConfig.linkedin },
    ];

    const contactLinks = [
        { icon: "ion-ios-location", label: contactResources[lang].Address, href: ContactConfig.addressLink },
        { icon: "ion-ios-email", label: ContactConfig.email, href: `mailto:${ContactConfig.email}` },
        { icon: "ion-ios-telephone", label: ContactConfig.phone, href: `tel:${ContactConfig.phone}` },
    ];

    return (
        <footer className="main-footer">
            <FadeInOnScroll delay={0.5}>
                <div className="footer-items">

                    <div className="logo">
                        <a className="footer-logo" href={getRoutePath(ROUTES.HOME, lang)}>
                            <img src="/images/fav.png" alt="Logo" />
                        </a>
                    </div>

                    <FooterSection title={resources[lang].Main}>
                        {mainLinks.map((link, idx) => (
                            <FooterLink key={idx} label={link.label} href={link.href} />
                        ))}
                    </FooterSection>


                    <FooterSection title={resources[lang].Services}>
                        {dropdownOptions[lang].services.map((item) => (
                            <FooterLink
                                key={item.id}
                                label={item.label}
                                onClick={() => handleScrollOrNavigate(item.id, getRoutePath(ROUTES.SERVICES, lang))}
                            />
                        ))}
                    </FooterSection>

                    <FooterSection title={contactResources[lang].SocialMedia || (lang === "ar" ? "وسائل التواصل" : "Social Media")}>
                        {socialLinks.map((link, idx) => (
                            <FooterLink key={idx} label={link.label} href={link.href} />
                        ))}
                    </FooterSection>

                    <FooterSection title={resources[lang].Contact}>
                        {contactLinks.map((link, idx) => (
                            <FooterContactLink
                                key={idx}
                                iconClass={link.icon}
                                label={link.label}
                                href={link.href}
                            />
                        ))}
                    </FooterSection>

                </div>

                <div className="txt-center copy-right">
                    <p>&copy; {resources[lang].CreatedBY} njhrxl.com | 2025</p>
                </div>
            </FadeInOnScroll>
        </footer>
    );
}

export default Footer;
